import { concurrent } from './concurrent';
import { custom, interaction, pageLoad, pageSegmentLoad } from './core';

/**
 * @deprecated use ufo: go/ufo
 */
export const metrics = {
	pageLoad,
	pageSegmentLoad,
	interaction,
	custom,
	concurrent,
};
